import React from 'react';
import './service.css';

function ServiceList({content:{id,service,description,icon}}) {
    return (
        <div className="service-block">
            <div className="service-img-container">     
                {icon}
            </div>
            <div className="service-content">
                <h1 className="service-content-title">{service}</h1>
                <p className="service-content-para">{description}</p>
            </div>
        </div>
    )
}

export default ServiceList
